<template>
  <v-container class="text-center">
    <h1>Confirm Email!</h1>
    <div class="mb-10">
      We've sent a 6-digit confirmation email to your email.
      Please enter the code in below box to verify your email.
    </div>

    <v-form
      ref="form"
      lazy-validation
      @submit="submit"
    >
      <v-text-field
        v-model="email"
        label="E-mail"
        type="email"
        required
        outlined
        :disabled="loading || disableEmail"
        :error-messages="emailErrors"
      ></v-text-field>

      <div class="mb-5 otp-box">
        <v-otp-input
          length="6"
          type="number"
          v-model="otp"
          @finish="submit"
          :disabled="loading"
          :error-messages="otpErrors"
        ></v-otp-input>
      </div>

      <v-btn color="primary" class="w-100 sh-green mb-2" x-large @click="submit">
        Verify
      </v-btn>
    </v-form>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength, minLength, email } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'

export default {
  name: 'VerifyEmail',

  mixins: [validationMixin],
  validations: {
    email: { required, email },
    otp: { required, minLength: minLength(6), maxLength: maxLength(6) }
  },
  computed: {
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Must be valid e-mail')
      !this.$v.email.required && errors.push('E-mail is required')
      return errors
    },
    otpErrors () {
      const errors = []
      if (!this.$v.otp.$dirty) return errors
      !this.$v.otp.minLength && errors.push('Code must be 6 characters long')
      !this.$v.otp.maxLength && errors.push('Code must be 6 characters long')
      !this.$v.otp.required && errors.push('Code is required')
      this.invalidOTP && errors.push('Invalid code')
      return errors
    }
  },

  data: () => ({
    otp: '',
    email: '',
    loading: false,
    invalidOTP: false,
    disableEmail: false
  }),
  created () {
    this.email = this.$store.getters['auth/regEmail']
    if (this.email !== '') {
      this.disableEmail = true
    }
  },
  methods: {
    ...mapActions({
      signIn: 'auth/SIGNIN'
    }),
    submit (e) {
      e.preventDefault()

      this.invalidOTP = false
      this.loading = true
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$api.auth.signUpVerify({
          email: this.email,
          code: this.otp
        }).then(({ data }) => {
          this.signIn(data).then(() => {
            this.$router.push({ name: 'cpanel.dashboard' })
          })
        }).catch(() => {
          this.invalidOTP = true
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.otp-box {
  padding: 0 50px;
}
</style>
